module.exports = __webpack_public_path__ + "static/img/images_ID001.e1b9722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_ID001.jpg
// module id = GrC4
// module chunks = 0